import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Review from "./Review";
import { useQuery } from "react-query";
import useAdmin from "../../hooks/useAdmin";
import Loding from "../Shared/Loding";
import useAxios from "../../hooks/useAxios";

const Reviews = () => {
  
const axiosPublic=useAxios()

  const{data:reviews, isLoading} =useQuery('reviews', ()=>axiosPublic.get('/review').then(res=>res.data))
if(isLoading){
  return <Loding/>
}
 
  return (
    <section className="text-gray-600  bg-[#FAF7F2] py-[80px]  ">
      
  <div className="max-w-[1170px] mx-auto px-[10px]">
  <h4 className='text-3xl  font-bold text-center mb-10'>Cheak Review  <span className='text-primary'>Then Trust Us</span></h4>
  
  <div className=' grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-5 place-items-center'>
{
               reviews?.map(review =><Review key={review._id}review={review} ></Review>)
}
           </div>     
            
  </div>
     
    </section>
  );
};

export default Reviews;